<template>
  <div class="home">
    <div class="container">
      <!-- <h2>UPLOAD YOUR DESK SETUP TO WIN</h2> -->
      <div class="step-desc">
        <div class="step1">①<br/>Take a photo of your desk setup.</div>
        <div class="step2">②<br/>Change the file name to  your name and  Upload.</div>
        <div class="step3">③<br/>Winner will be announced on 11 December 2023.</div>
      </div>
      <form class="content-block">
        <ul>
          <li>
            <!-- <label for="name">Name</label> -->
            <input
              type="text"
              :style="bindInputStyle"
              id="name"
              maxlength="18"
              placeholder="Name (up to 18 characters)"
              v-model="userData.name"
              required
            />
          </li>
          <li>
            <!-- <label for="email">Email Address</label> -->
            <input
              type="email"
              ref="emailInput"
              :style="bindInputStyle"
              id="email"
              placeholder="Email address"
              v-model="userData.email"
              required
            />
          </li>
          <li>
            <!-- <label for="nation">Nation</label> -->
            <select
              id="nation"
              name="nation"
              class="form-control"
              v-model="userData.nation"
            >
              <option value="Afghanistan">Afghanistan</option>
              <option value="Åland Islands">Åland Islands</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="American Samoa">American Samoa</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Anguilla">Anguilla</option>
              <option value="Antarctica">Antarctica</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Aruba">Aruba</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bermuda">Bermuda</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">
                Bosnia and Herzegovina
              </option>
              <option value="Botswana">Botswana</option>
              <option value="Bouvet Island">Bouvet Island</option>
              <option value="Brazil">Brazil</option>
              <option value="British Indian Ocean Territory">
                British Indian Ocean Territory
              </option>
              <option value="Brunei Darussalam">Brunei Darussalam</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Cape Verde">Cape Verde</option>
              <option value="Cayman Islands">Cayman Islands</option>
              <option value="Central African Republic">
                Central African Republic
              </option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Christmas Island">Christmas Island</option>
              <option value="Cocos (Keeling) Islands">
                Cocos (Keeling) Islands
              </option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo">Congo</option>
              <option value="Congo, The Democratic Republic of The">
                Congo, The Democratic Republic of The
              </option>
              <option value="Cook Islands">Cook Islands</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Cote D'ivoire">Cote D'ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Falkland Islands (Malvinas)">
                Falkland Islands (Malvinas)
              </option>
              <option value="Faroe Islands">Faroe Islands</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="French Guiana">French Guiana</option>
              <option value="French Polynesia">French Polynesia</option>
              <option value="French Southern Territories">
                French Southern Territories
              </option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Gibraltar">Gibraltar</option>
              <option value="Greece">Greece</option>
              <option value="Greenland">Greenland</option>
              <option value="Grenada">Grenada</option>
              <option value="Guadeloupe">Guadeloupe</option>
              <option value="Guam">Guam</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guernsey">Guernsey</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-bissau">Guinea-bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Heard Island and Mcdonald Islands">
                Heard Island and Mcdonald Islands
              </option>
              <option value="Holy See (Vatican City State)">
                Holy See (Vatican City State)
              </option>
              <option value="Honduras">Honduras</option>
              <option value="Hong Kong">Hong Kong</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran, Islamic Republic of">
                Iran, Islamic Republic of
              </option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Isle of Man">Isle of Man</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jersey">Jersey</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, Democratic People's Republic of">
                Korea, Democratic People's Republic of
              </option>
              <option value="Korea, Republic of">Korea, Republic of</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Lao People's Democratic Republic">
                Lao People's Democratic Republic
              </option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libyan Arab Jamahiriya">
                Libyan Arab Jamahiriya
              </option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Macao">Macao</option>
              <option value="Macedonia, The Former Yugoslav Republic of">
                Macedonia, The Former Yugoslav Republic of
              </option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Martinique">Martinique</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mayotte">Mayotte</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia, Federated States of">
                Micronesia, Federated States of
              </option>
              <option value="Moldova, Republic of">Moldova, Republic of</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar">Myanmar</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="Netherlands Antilles">Netherlands Antilles</option>
              <option value="New Caledonia">New Caledonia</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="Niue">Niue</option>
              <option value="Norfolk Island">Norfolk Island</option>
              <option value="Northern Mariana Islands">
                Northern Mariana Islands
              </option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Palestinian Territory, Occupied">
                Palestinian Territory, Occupied
              </option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Pitcairn">Pitcairn</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Puerto Rico">Puerto Rico</option>
              <option value="Qatar">Qatar</option>
              <option value="Reunion">Reunion</option>
              <option value="Romania">Romania</option>
              <option value="Russian Federation">Russian Federation</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Helena">Saint Helena</option>
              <option value="Saint Kitts and Nevis">
                Saint Kitts and Nevis
              </option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Pierre and Miquelon">
                Saint Pierre and Miquelon
              </option>
              <option value="Saint Vincent and The Grenadines">
                Saint Vincent and The Grenadines
              </option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">
                Sao Tome and Principe
              </option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Georgia and The South Sandwich Islands">
                South Georgia and The South Sandwich Islands
              </option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Svalbard and Jan Mayen">
                Svalbard and Jan Mayen
              </option>
              <option value="Swaziland">Swaziland</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syrian Arab Republic">Syrian Arab Republic</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania, United Republic of">
                Tanzania, United Republic of
              </option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-leste">Timor-leste</option>
              <option value="Togo">Togo</option>
              <option value="Tokelau">Tokelau</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Turks and Caicos Islands">
                Turks and Caicos Islands
              </option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="United States Minor Outlying Islands">
                United States Minor Outlying Islands
              </option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Viet Nam">Viet Nam</option>
              <option value="Virgin Islands, British">
                Virgin Islands, British
              </option>
              <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
              <option value="Wallis and Futuna">Wallis and Futuna</option>
              <option value="Western Sahara">Western Sahara</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>
          </li>
          <li>
            <!-- <label for="description">Description</label> -->
            <textarea
              :style="bindInputStyle"
              id="description"
              cols="30"
              rows="4"
              maxlength="100"
              placeholder="Description (up to 100 characters)"
              v-model="userData.description"
              required
            ></textarea>
          </li>
          <div class="upload-block" v-if="imgSrc === ''">
            <label for="choose-img" class="choose-btn">
              <img src="../../public/upload-icon.svg" alt="">
            </label>
            <input
              id="choose-img"
              type="file"
              accept="image/png, image/jpeg"
              style="display: none"
              @change="getImgUrl($event)"
            />
          </div>
          <div class="upload-block preview" v-else>
            <div class="uploaded-img">
              <img :src="imgSrc" alt="preview image" />
            </div>
            <div class="re-choose-btn">
              <label for="re-choose-img" class="btn"></label>
              <input
                id="re-choose-img"
                type="file"
                accept="image/png, image/jpeg"
                style="display: none"
                @change="getImgUrl($event)"
              />
              <div class="uploading" v-show="isLoading">
                <div class="color"></div>
              </div>
            </div>
          </div>
          <div class="privacy">* The giveaway items are exclusively available for participation within the US, CA, and UK.</div>
          <li>
            <label for="privacy" class="privacy-label">
              <input
                type="checkbox"
                ref="checkbox"
                id="privacy"
                v-model="isCheck"
                required
              />
              <div class="click-area" v-if="!isCheck"></div>
              <div class="click-area click-area-checked" v-if="isCheck">✓</div>
            </label>
            <label for="privacy" class="privacy" 
              >I have read and agree to the
              <a
                href="https://www.benq.com/en-us/policy/privacy-policy.html"
                target="_blank"
                >privacy policy</a
              >.
            </label>
          </li>
        </ul>
        <button class="btn" @click.prevent="uploadImg" :disabled="!isCheck">
          Upload
        </button>
      </form>
    </div>
    <div class="submit" v-if="isSubmit">
      <div class="submit-content" data-aos="zoom-in" data-aos-duration="400">
        <p>
          Uploading success!<br />
          Your photo is under review.
        </p>
        <button @click="closeSubmit" class="btn">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadImage } from "../api/benq.js";
export default {
  name: "Home202312",
  data() {
    return {
      userData: {
        imgSrc: "",
        name: "",
        email: "",
        description: "",
        nation: "United States"
      },
      imgSrc: "",
      uploadData: "",
      isLoading: false,
      isCheck: false,
      isSubmit: false,
      inputColor: "#FFFFFF"
    };
  },
  methods: {
    uploadImg() {
      const emailRegxp = /^([\w]+)(.[\w]+)*@([\w]+)(.[\w]{2,3}){1,2}$/;
      // 驗證圖片
      if (this.imgSrc === "") {
        alert("please upload photo");
        return;
      }
      // 驗證名字、email、descrition
      if (
        this.userData.name === "" ||
        this.userData.email == "" ||
        this.userData.description === ""
      ) {
        this.inputColor = "red";
        setTimeout(() => {
          this.inputColor = "#626466";
        }, 1000);
      } else if (emailRegxp.test(this.userData.email) != true) {
        alert("Email format error");
        this.$refs.emailInput.focus();
      } else {
        const formData = new FormData();
        formData.append("files.image", this.uploadData);
        // 為了符合 strapi 上傳圖片規範，傳入 obj 空物件
        let obj = {
          published_at: null,
          name: this.userData.name.trim(),
          email: this.userData.email.trim(),
          description: this.userData.description.trim(),
          nation: this.userData.nation.trim()
        };
        formData.append("data", JSON.stringify(obj));
        uploadImage(formData)
          .then((response) => {
            if (response.status === 200) {
              this.isSubmit = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getImgUrl(e) {
      this.isLoading = true;
      this.imgSrc = URL.createObjectURL(e.target.files[0]);
      this.uploadData = e.target.files[0];
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
    },
    closeSubmit() {
      this.userData = {
        imgSrc: "",
        name: "",
        email: "",
        description: "",
        nation: "United States"
      };
      this.imgSrc = "";
      this.isCheck = false;
      this.isSubmit = false;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  computed: {
    bindInputStyle() {
      return {
        "--placeholderColor": this.inputColor,
      };
    },
  },
  mounted() {
    function setHeight() {
      const _h = document.body.scrollHeight; //取得網頁高度
      parent.postMessage({ h: _h }, "*"); //將高度值，傳到父層
    }
    setHeight();
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/style/SCSS/_mixin.scss";

.home, body, html{
  background-color: #000 !important;
}

*{
  font-family: "poppins", "Poppins" !important;
  -webkit-appearance: none;
}

.container{
  max-width: 1920px;
}


h2 {
  padding: 32px 0;
  font-size: 42px;
  letter-spacing: 0.1rem;
  font-weight: 600;
  // font-style: italic;
  text-align: center;
  color: white;
}

.step-desc{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  div{
    margin: 10px;
    text-align: center;
    line-height: 1.2;
    font-size: 16px;
  }
}
.upload-block {
  height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #565656;
  // background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23AD9874FF' stroke-width='3' stroke-dasharray='20' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
.upload-block.preview {
  position: relative;
  // padding: 20px;
  // display: grid;
  // grid-template-columns: 1fr 1fr;
  @include mobile {
    // grid-template-columns: 1fr;
    // grid-template-rows: 2fr 1fr;
  }
}
.uploading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #565656;
  .color {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left;
    background-color: #000;
    border: 1px solid white;
    width: 120px;
    height: 18px;
    border-radius: 0px;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: white;
      clip-path: polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%);
      animation: progress 2s linear;
    }
    @include mobile {
      width: 250px;
    }
  }
}
@keyframes progress {
  0% {
    clip-path: polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%);
  }
  25% {
    clip-path: polygon(0% 0%, 50% 0%, 50% 100%, 0% 100%);
  }
  50% {
    clip-path: polygon(0% 0%, 75% 0%, 75% 100%, 0% 100%);
  }
  75% {
    clip-path: polygon(0% 0%, 85% 0%, 85% 100%, 0% 100%);
  }
  100% {
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
}
.uploaded-img {
  display: flex;
  justify-content: center;
  height: 100%;
  overflow: hidden;
}

.re-choose-btn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  .btn{
    width: 100%;
    height: 100%;
    margin: 0 !important;
    padding: 0;
    left: 0;
    top: 0;
    transform: translateX(0);
    background: rgba(0,0,0,0) !important;
  }
}

.content-block {
  margin: 32px auto 0px auto;
  padding-bottom: 80px;
  width: 50%;
  @include pad {
    width: 80%;
  }
  @include mobile {
    width: 100%;
  }
  li {
    padding-bottom: 24px;
    position: relative;
    display: flex;
    flex-direction: column;
    &:last-child {
      display: block;
      label {
        padding-left: 16px;
        font-weight: normal;
        @include mobile {
          padding-left: 0px;
        }
      }
    }
  }
  label {
    padding-bottom: 8px;
    font-size: 0.6rem;
    font-weight: bold;
  }
  input,
  textarea, select {
    position: relative;
    padding: 8px 16px;
    background-color: #565656;
    vertical-align: middle;
    border: 0px solid $sub-color;
    border-radius: 0px;
    font-family: "Poppins", sans-serif;
    font-size: 16px;
    min-height: 42px;
    color: #FFFFFF;
    &::placeholder {
      color: var(--placeholderColor);
    }
  }

  // select::after{
  //   content: 'v';
  //   color: white;
  //   position: absolute;
  //   right: 10px;
  //   top: 50%;
  //   transform: translateY(-50%);
  // }

  input[type="checkbox"] {
    transform: scale(1.5);
    transform-origin: center;
    accent-color: #000;
    border: 1px solid white;
    @include mobile {
      transform: scale(1);
      background-color: #000;
      border: 1px solid white;
    }
  }

  a {
    font-size: 12px;
  }
  
  .btn {
    margin-top: 30px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.3s ease;
    background: #e1e1e1;
    color: black;
    opacity: 1;
    cursor: pointer;
    border-radius: 0px;

    &:disabled {
      opacity: 0.3;
      transition: all 0.3s ease;
      cursor: initial;
    }
  }
}

.choose-btn{
  scale: 1;
  cursor: pointer;
  transition: 0.3s;
  &:hover{
    scale: 0.95;
  }
}

.privacy{
  color: white;
  font-size: 12px;
  margin: 20px 0 10px 0;
  cursor: pointer;
  @include mobile {
    font-size: 14px !important;
    margin-left: 10px;
  }
}

.privacy-label{
  width: 26px;
  height: 26px;
  font-size: 14px !important;
  padding-left: 0px !important;
  cursor: pointer;
  
  @include mobile {
    width: 30px;
    height: 30px; 
  }
  input[type=checkbox] {
    width: 26px;
    height: 26px;
    display: none;
    @include mobile {
      width: 30px;
      height: 30px; 
    }
  }

  
  .click-area{
    width: 26px;
    height: 26px;
    border: 1px white solid;
    background-color: rgba(0,0,0,0);
    display: inline-block;
    vertical-align: middle;
    @include mobile {
      width: 30px;
      height: 30px; 
    }
  }

  .click-area-checked{
    color: white;
    font-size: 18px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    // background-color: white;
  }

  @include mobile {
    font-size: 14px;
  }
}

.arrow {
  display: inline-block;
  width: 15px;
  height: auto;
}
.submit {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.submit-content {
  padding: 80px 120px;
  max-width: 790px;
  text-align: center;
  background-color: #fff;
  p {
    padding-bottom: 32px;
    font-size: 1.2rem;
    font-weight: bold;
  }
  @include mobile {
    padding: 30px;
  }
}
</style>